module.exports = __webpack_public_path__ + "class_en@2x.84c1efdd.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/pages/Class/images/class_en@2x.png
// module id = 19ka
// module chunks = 0